/* eslint-disable @typescript-eslint/strict-boolean-expressions */
// istanbul ignore file
import interceptedAxios from '../../../utils/interceptedAxios'
import { z } from 'zod'

const ZRead = z.object({
  readingTime: z.string(),
  value: z.number(),
  indexValue: z.number()
})

const ZReadingcimCodeIds = z.object({
  assetId: z.string(),
  cimCodeId: z.string(),
  units: z.string().optional(),
  errorMessage: z.string().optional(),
  totalCount: z.number(),
  registerName: z.string().optional(),
  assetIntervalReadingsData: z.array(ZRead)
})

const ZIntervalReadingAssetData = z.object({
  assetId: z.string(),
  totalCount: z.number(),
  errorMessage: z.string().optional(),
  assetIntervalReadingsData: z.array(ZReadingcimCodeIds)
})

const ZIntervalReadingData = z.object({
  allAssetsResponse: z.array(ZIntervalReadingAssetData)
})

const ZIntervalReading = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: ZIntervalReadingData
})

const DeviceCimCodeIdsPayload = z.object({
  deviceId: z.string(),
  cimCodeIds: z.array(z.string())
})

const ZDevicePayload = z.object({
  devices: z.array(DeviceCimCodeIdsPayload)
})

export type intervalData = z.infer<typeof ZIntervalReadingData>
export type deviceInterface = z.infer<typeof ZDevicePayload>

export type flameReadingData = z.infer<typeof ZIntervalReading>

export async function getFlameSignaGraphData (
  siteId: string,
  assetId: string,
  cimCodeIds: deviceInterface,
  startDateTime: string,
  endDateTime: string,
  graphName: string,
  onSuccess: (data: any, httpStatus: number) => any,
  onFailure: (errorMessage: string, httpStatus: number) => any
): Promise<void> {
  const url = `/asset-data-service/api/v1/udp/tiq/assets/data/interval/asset-interval-readings/${siteId}/${assetId}?&startDate=${startDateTime.replace('%20', ' ')}&endDate=${endDateTime.replace('%20', ' ')}&graphName=${graphName}`
  interceptedAxios.post(url, cimCodeIds, { timeout: 30000 })
    .then((response) => {
      if (response.status === 200) {
        const parseResponse = ZIntervalReading.safeParse(response.data)
        if (parseResponse.success) {
          if (response.data.data !== null && response.data.data !== undefined) {
            onSuccess(parseResponse.data.data, response.status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.message, error.response.status)
        }
      } else {
        onFailure(error.message, error.status)
      }
    })
}
